import * as React from "react"
import { Cell, CellType } from "@tenforce/toolbox-table-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import SiblingRow from "./SiblingRow"
import {
    DragDropContext,
    Droppable,
    Draggable,
    DropResult,
} from "react-beautiful-dnd"
import { ISibling } from "../index"

interface Props {
    isReorderingDisabled: boolean
    siblings: ISibling[]
    removeSibling: (selectionFilterId: string) => void
    reorderSiblings: (
        targetLocation: number,
        oldLocation: number,
        reorderedSiblingId: string,
        targetSiblingId: string,
    ) => void
}

export default class EditableSiblings extends React.PureComponent<Props> {
    render(): JSX.Element {
        const { isReorderingDisabled, siblings, removeSibling } = this.props

        return (
            <>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="relativeSiblingsDroppable">
                        {(provided): JSX.Element => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {siblings.map((sibling, index) => (
                                    <Draggable
                                        key={sibling.Id}
                                        draggableId={sibling.Id}
                                        index={index}
                                        isDragDisabled={isReorderingDisabled}
                                    >
                                        {(
                                            draggableProvided,
                                            snapshot,
                                        ): JSX.Element => {
                                            const dragHandler = (
                                                <Cell
                                                    type={CellType.action}
                                                    extraClasses={`toolbox-table__cell--0 tw-cursor-move ${
                                                        snapshot.isDragging
                                                            ? ""
                                                            : "hiddenAction"
                                                    }`}
                                                    data-ft-action="drag"
                                                    {...draggableProvided.dragHandleProps}
                                                >
                                                    <div className="toolbox-action toolbox-action--icon tw-cursor-move">
                                                        {Symbols.Reorder}
                                                    </div>
                                                </Cell>
                                            )

                                            return (
                                                <div
                                                    {...draggableProvided.draggableProps}
                                                    ref={
                                                        draggableProvided.innerRef
                                                    }
                                                    className="draggableRow"
                                                >
                                                    <SiblingRow
                                                        sibling={sibling}
                                                        dragHandler={
                                                            dragHandler
                                                        }
                                                        isDragging={
                                                            snapshot.isDragging
                                                        }
                                                        isDraggable={
                                                            !isReorderingDisabled
                                                        }
                                                        removeSibling={
                                                            removeSibling
                                                        }
                                                    />
                                                </div>
                                            )
                                        }}
                                    </Draggable>
                                ))}

                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </>
        )
    }

    onDragEnd = (result: DropResult): void => {
        const { siblings, reorderSiblings } = this.props
        const { destination, source } = result

        if (!!destination && destination.index !== source.index) {
            reorderSiblings(
                destination.index,
                source.index,
                siblings[source.index].Id,
                siblings[destination.index].Id,
            )
        }
    }
}
